import { render } from "./UserGravatar.vue?vue&type=template&id=206ab4a0"
import script from "./UserGravatar.vue?vue&type=script&lang=js"
export * from "./UserGravatar.vue?vue&type=script&lang=js"
script.render = render

export default script